import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default function DiscountView({ item, labels, onRemove }) {
    const DeleteButton = ComponentRegistry.get("DeleteButton");

    return (
      <tr>
        <td>{item.code}</td>
        <td colSpan="3">{item.description}</td>
        <td>- {item.value}</td>
        <td><DeleteButton onClick={onRemove}>{labels.remove}</DeleteButton></td>
      </tr>
    );
}

DiscountView.propTypes = {
    item: PropTypes.shape({
        code: PropTypes.string,
        description: PropTypes.string,
        value: PropTypes.string,
    }).isRequired,
    labels: PropTypes.shape({
        remove: PropTypes.string,
    }).isRequired,
    onRemove: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Basket/Views/DiscountView.jsx